export default __webpack_public_path__ + "static/media/fed-form-2441-child-and-dependent-care-expenses.6f0b979b.svg";